module.exports = __webpack_public_path__ + "img/guilty-tags.f552097c.jpg";